import { ComponentPortal } from '@angular/cdk/portal';
import { Component, ComponentRef, ElementRef, EnvironmentInjector, EventEmitter, NgZone, Output, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'cdm-manizales-notification-container',
  templateUrl: './notification-container.component.html',
  styleUrls: ['./notification-container.component.scss'],
})
export class NotificationContainerComponent {
  @ViewChild('container', { read: ViewContainerRef, static: true }) container: ViewContainerRef;
  @ViewChild('containerCards') containerCards: ElementRef;
  @Output() allClosed = new EventEmitter<void>();
  notifications: ComponentRef<any>[] = [];

  constructor(
    private environmentInjector: EnvironmentInjector,
    private ngZone: NgZone
  ) {}

  addNotification(notification: ComponentPortal<any>): ComponentRef<any> {
    const notificationRef =  this.container.createComponent(notification.component, { environmentInjector: this.environmentInjector });
    this.notifications.push(notificationRef);

    setTimeout(() => {
      this.ngZone.runOutsideAngular(() => {
        this.scrollToBottom();
      });
    });

    return notificationRef;
  }

  removeNotification(notificationRef: ComponentRef<any>) {
    const index = this.notifications.indexOf(notificationRef);
    if (index >= 0) {
      this.notifications.splice(index, 1);
      notificationRef.destroy();
    }
  }

  closeAll() {
    while (this.notifications.length > 0) {
      const notificationRef = this.notifications.pop();
      if (notificationRef) {
        notificationRef.destroy();
      }
    }
    this.allClosed.emit();
  }

  scrollToBottom(): void {
    try {
      this.containerCards.nativeElement.scrollTop = this.containerCards.nativeElement.scrollHeight;
    } catch (err) {
      console.error("scroll to bottom: ", err);
    }
  }
}
